<script lang="ts" setup>
import { TrackingService } from '@/client/services'

function handleLinkClick(): void {
  TrackingService.sendEvent('click:ヘルプ')
}
</script>

<template>
  <a class="help" href="https://help-atelu.comnico.jp/" target="_blank" @click="handleLinkClick">
    <i class="mdi mdi-help-circle" />
    ヘルプ
  </a>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.help {
  display: flex;
  gap: $spacing-unit;
  align-items: center;
  color: $text-color-white;

  &:hover {
    text-decoration: none;
    opacity: 0.8;
  }
}
</style>
